import React from 'react';
import { get } from '../../util/api';
import _ from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import { Box, Button, MenuItem, Select, Switch, Table, TableBody, TableCell, TableHead, TableRow, TextField, TablePagination, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import DirectionsIcon from '@mui/icons-material/Directions';

const RefreshBtn = (props) => {
	const [loading, setLoading] = React.useState(false);
	function onclick() {
		setLoading(true);
		get('/maytapi/refreshSubscription/' + props.uid).then(() => {
			setLoading(false);
		});
	}

	return (
		<Button onClick={onclick} loading={loading}>
			<RefreshIcon />
		</Button>
	);
};

export default function Footprint() {
	const [loading, setLoading] = React.useState(true);
	const [data, setData] = React.useState({});
	const [onlysubs, setOnlySubs] = React.useState(true);
	const [hideFree, sethideFree] = React.useState(false);
	const [multiInstance, setMultiInstance] = React.useState(false);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(50);
	const [searchTerm, setSearchTerm] = React.useState('');
	const [versionFilter, setVersionFilter] = React.useState({ apiVersion: '', lastVersion: '' });

	React.useEffect(() => {
		get('/maytapi/admin/phoneList').then((temp) => {
			setLoading(false);
			const { phones, products } = temp;
			const map_pro = {},
				sub_pro = {};
			_.each(products, (it) => {
				map_pro[it.id] = it;
				if (it.sub)
					if (sub_pro[it.id]) sub_pro[it.id].push(it.sub);
					else sub_pro[it.id] = [it.sub];
			});
			setData({
				list: _.orderBy(
					_.map(_.filter(phones, { type: 'whatsapp' }), (it) => {
						it.product = map_pro[it.pid];
						it.sub = sub_pro[it.pid];
						it.subscription = it.product &&
							it.product.settings &&
							it.product.settings.subscription_package && [
								it.product.settings.subscription_package,
								it.product.settings.phone_limit,
								it.product.settings.agent_limit,
								it.product.settings.instagram_limit,
							];
						let token = (it.product && it.product.settings && it.product.settings.wapi_token) || temp.token;
						it.url = `https://api.maytapi.com/api/${it.pid}/${it.id}/screen?token=${token}`;
						it.backupUrl = `https://api.maytapi.com/api/${it.pid}/${it.id}/backup_start?token=${token}`;
						it.token = token;
						it.copy_text = JSON.stringify(it, null, 2);
						return it;
					}),
					'id'
				),
			});
		});
	}, []);
	if (loading) return <Box attached="bottom">loading...</Box>;

	const { column, list, direction } = data;
	function handleSort(clickedColumn) {
		return () => {
			if (column !== clickedColumn) {
				setData({
					column: clickedColumn,
					list: _.sortBy(list, [clickedColumn]),
					direction: 'ascending',
				});

				return;
			}

			setData({
				column: clickedColumn,
				list: list.reverse(),
				direction: direction === 'ascending' ? 'descending' : 'ascending',
			});
		};
	}
	let filteredlist = list;
	console.log(filteredlist);
	if (onlysubs) {
		filteredlist = _.filter(list, (it) => it.subscription);
	}
	if (multiInstance) {
		filteredlist = _.filter(list, (it) => it.sessionId);
	}
	if (hideFree) {
		filteredlist = _.filter(list, (it) => it.sessionId !== 'free');
	}

	if (searchTerm) {
		filteredlist = _.filter(filteredlist, (it) => {
			const searchableText = [it.id, it.pid, it.product?.email, it.status, it.number, it.auth, it.subscription?.[0], it.sessionId]
				.join(' ')
				.toLowerCase();

			return searchableText.includes(searchTerm.toLowerCase());
		});
	}
	if (versionFilter.apiVersion) {
		filteredlist = _.filter(filteredlist, (it) => (it.api_version || '').includes(versionFilter.apiVersion));
	}
	if (versionFilter.lastVersion !== '') {
		const expected = versionFilter.lastVersion === 'true';
		filteredlist = _.filter(filteredlist, (it) => Boolean(it.lastVersion) === expected);
	}

	const totalCount = filteredlist.length;
	const startIndex = page * rowsPerPage;
	const endIndex = startIndex + rowsPerPage;
	const paginatedList = filteredlist.slice(startIndex, endIndex);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	return (
		<Box attached="bottom">
			<Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
				{totalCount} / {(list && list.length) || 0} phones
			</Typography>
			<div style={{ marginBottom: '20px' }}>
				<TextField
					placeholder="Search..."
					value={searchTerm}
					onChange={(e) => {
						setSearchTerm(e.target.value);
						setPage(0);
					}}
					style={{ marginRight: '20px', width: '300px' }}
				/>
				<label>Only Subs</label>
				<Switch toggle name="onlysubs" checked={onlysubs} onClick={() => setOnlySubs(!onlysubs)} />
				<label>Hide Idle-Free</label>
				<Switch toggle name="hideFree" checked={hideFree} onClick={() => sethideFree(!hideFree)} />
				<Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', border: '1px solid', borderColor: (versionFilter.apiVersion || versionFilter.lastVersion) ? 'primary.main' : 'divider', borderRadius: 1, px: 0.5, ml: 2 }}>
					<Typography variant="caption" sx={{ mr: 0.5, fontWeight: 'bold', color: (versionFilter.apiVersion || versionFilter.lastVersion) ? 'primary.main' : 'text.secondary' }}>
						version
					</Typography>
					<TextField
						size="small"
						placeholder="1.5.1"
						value={versionFilter.apiVersion}
						onChange={(e) => { setVersionFilter((f) => ({ ...f, apiVersion: e.target.value })); setPage(0); }}
						sx={{ width: 70, '& .MuiInputBase-input': { fontSize: 12, py: 0.5, px: 0.5 }, '& .MuiOutlinedInput-notchedOutline': { border: 'none' } }}
					/>
					<Select
						size="small"
						value={versionFilter.lastVersion}
						onChange={(e) => { setVersionFilter((f) => ({ ...f, lastVersion: e.target.value })); setPage(0); }}
						displayEmpty
						sx={{ fontSize: 12, height: 28, '.MuiOutlinedInput-notchedOutline': { border: 'none' }, minWidth: 50 }}
					>
						<MenuItem value="">All</MenuItem>
						<MenuItem value="true">✓</MenuItem>
						<MenuItem value="false">✗</MenuItem>
					</Select>
					{(versionFilter.apiVersion || versionFilter.lastVersion) && (
						<Button size="small" onClick={() => { setVersionFilter({ apiVersion: '', lastVersion: '' }); setPage(0); }} sx={{ minWidth: 0, p: 0.2, fontSize: 11, color: 'text.secondary' }}>
							✕
						</Button>
					)}
				</Box>
			</div>

			<Table sortable celled>
				<TableHead>
					<TableRow>
						<TableCell textAlign="center" style={{ width: 70 }} collapsing sorted={column === 'id' ? direction : null} onClick={handleSort('id')}>
							ID
						</TableCell>
						<TableCell sorted={column === 'pid' ? direction : null} onClick={handleSort('pid')}>
							Product
						</TableCell>
						<TableCell sorted={column === 'subscription' ? direction : null} onClick={handleSort('subscription')}>
							Subscription
						</TableCell>
						<TableCell sorted={column === 'status' ? direction : null} onClick={handleSort('status')}>
							Status
						</TableCell>
						<TableCell>Version</TableCell>
						<TableCell>Number</TableCell>
						<TableCell></TableCell>
						<TableCell></TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{_.map(paginatedList, (it) => {
						let { id, pid, product, number, auth, status, subscription, copy_text } = it;
						//console.log(subscription);
						return (
							<TableRow key={id}>
								<TableCell textAlign="center">
									<CopyToClipboard text={copy_text}>
										<span>
											{id}
											<a href={it.url} target="_blank" rel="noopener noreferrer">
												<DirectionsIcon />
											</a>
										</span>
									</CopyToClipboard>
								</TableCell>
								<TableCell>
									{product ? (
										<a href={'/yta/logs?uid=' + product.uid} target="_blank" rel="noopener noreferrer">
											{product.email}
										</a>
									) : (
										pid
									)}
								</TableCell>

								<TableCell>
									{subscription && (
										<div>
											{subscription[0]} - [{'P:' + subscription[1] || 0},{'A:' + subscription[2] || 0},{'I:' + subscription[3] || 0}]
										</div>
									)}
								</TableCell>
								<TableCell>
									{status}
									{it.sessionId ? ` [${it.sessionId}]` : ''}
								</TableCell>
								<TableCell sx={{ fontFamily: 'monospace', fontSize: 12, whiteSpace: 'nowrap' }}>
									{it.api_version ? (
										<>
											{it.api_version}
											<span style={{ marginLeft: 4, color: it.lastVersion ? '#2e7d32' : '#c62828' }}>
												({it.lastVersion ? '✓' : '✗'})
											</span>
										</>
									) : '—'}
								</TableCell>
								<TableCell>{(number || auth) && `${number}, ${auth}`}</TableCell>

								<TableCell>{product && product.uid && <RefreshBtn uid={product.uid} />}</TableCell>

								<TableCell>
									<span>
										<a href={it.backupUrl} target="_blank" rel="noopener noreferrer">
											<DirectionsIcon />
										</a>
									</span>
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>

			<TablePagination
				rowsPerPageOptions={[10, 25, 50, 100]}
				component="div"
				count={totalCount}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</Box>
	);
}
